var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNodes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 6)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41.912a4.614 4.614 0 014.47 2.516 4.623 4.623 0 01-.613 5.097A4.612 4.612 0 017.33 9.908 4.619 4.619 0 014.163 5.87 4.618 4.618 0 018.41.912z",
    opacity: 0.47,
    fill: "#6BC6C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44.024a4.614 4.614 0 014.47 2.516 4.623 4.623 0 01-.612 5.097A4.612 4.612 0 016.359 9.02a4.619 4.619 0 01-3.166-4.039A4.618 4.618 0 017.439.024z",
    stroke: "#292D3B",
    strokeWidth: 1.208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#292D3B",
    strokeWidth: 1.208,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 25.103,
    cy: 26.171,
    rx: 9.151,
    ry: 9.162
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#17202D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.804 31.11c2.563 0 4.648-2.154 4.648-4.803-.002-.25-.023-.5-.063-.748.005.082.014.166.014.245 0 2.322-1.826 4.209-4.071 4.209a3.943 3.943 0 01-2.532-.916c-.317.27-.543.473-1.195.685.834.81 1.97 1.329 3.199 1.329zM21.26 25.801c0-2.322 1.827-4.209 4.072-4.209.19.002.379.017.566.046a4.501 4.501 0 00-1.094-.138c-2.563 0-4.648 2.156-4.648 4.807.006.602.11 1.198.31 1.766.282-.295.749-.609 1.053-.76-.184-.48-.258-.962-.258-1.508V25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.994 25.02c-.82-.288-1.61-.057-1.98.089.585.302.949.669 1.173.99.224-.332.728-.978.807-1.078zM25.617 27.403a3.998 3.998 0 00-.04-.326 7.374 7.374 0 01-1.29.72l-.052.023a2.699 2.699 0 01.087.219 5.05 5.05 0 01.148.461l.033.134c.062.263.095.532.098.802 0 .062-.011.125-.015.187a2.408 2.408 0 001.039-1.971V27.6c0-.025 0-.05-.002-.075 0-.041-.004-.082-.007-.123h.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.878 22.152c.2.017.397.05.59.1-.928 2.404-2.705 3.814-4.046 4.577-.166.095-.29.163-.448.241a8.057 8.057 0 00-.096-.586.055.055 0 00-.088-.033 8.85 8.85 0 01-1.988 1.136.095.095 0 00-.05.127l.079.163a51.59 51.59 0 00-.436.108c-.049-.26-.239-.598-.445-.75a10.413 10.413 0 01.384-.642c.026-.04.048-.076.074-.114.296-.447.616-.877.958-1.29l.076-.092.076-.09c.743-.876 1.663-1.76 2.603-2.262.6-.325 1.26-.524 1.94-.586-.137.244-.378.578-.808.978a.114.114 0 00-.026.034.257.257 0 00-.025.113c0 .127.089.258.197.345.163.131.34.153.452.054l.032-.028c.514-.439.843-.945.995-1.503zm-3.932 3.944a.426.426 0 10-.412-.426.419.419 0 00.412.426zm.923-.72a.426.426 0 11.412-.427.42.42 0 01-.411.426zm.884-.713a.426.426 0 11.412-.426.42.42 0 01-.412.426zM22.57 27.489c.227.016.44.448.433.558-.01.144-.064.381-.473.772l-.01.009-.005.005c-.313.297-.751.498-1.205.634l-.014.004-.01.003a7.74 7.74 0 01-1.784.272c.341-.456.718-.883 1.127-1.28l.007-.006.01-.01c.412-.389.76-.627 1.043-.77l.01-.005.01-.006c.476-.236.763-.203.856-.181l.006.002m-.041.467a.433.433 0 00.105-.11c.004-.02-.023-.038-.05-.074-.152-.194-.666.003-.897.137a3.407 3.407 0 00-.9.815l-.009.011-.006.009-.043.061.05-.048.008-.006a.106.106 0 01.01-.01c.17-.158.631-.565.973-.664.038-.007-.21.612-.21.612l.528-.386a16.113 16.113 0 00.342-.266l.1-.081h-.001z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#292D3B",
    strokeWidth: 1.208,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.577 8.345l9.21 10.374M18.767 33.003L8.058 41.604M44.107 35.57L33.26 30.395M33.6 22.687l10.591-5.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.897 11.053a4.614 4.614 0 014.47 2.516 4.623 4.623 0 01-.611 5.097 4.612 4.612 0 01-4.939 1.383 4.619 4.619 0 01-3.166-4.038 4.62 4.62 0 011.097-3.36 4.61 4.61 0 013.15-1.598z",
    opacity: 0.47,
    fill: "#6BC6C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.927 10.165a4.614 4.614 0 014.47 2.516 4.623 4.623 0 01-.611 5.097 4.612 4.612 0 01-4.939 1.384 4.619 4.619 0 01-3.166-4.038 4.617 4.617 0 014.246-4.959z",
    stroke: "#292D3B",
    strokeWidth: 1.208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34 41.6a4.614 4.614 0 014.47 2.516 4.623 4.623 0 01-.612 5.097 4.612 4.612 0 01-4.938 1.383 4.619 4.619 0 01-3.167-4.038 4.62 4.62 0 011.097-3.36A4.61 4.61 0 015.34 41.6z",
    opacity: 0.47,
    fill: "#6BC6C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37 40.717a4.614 4.614 0 014.47 2.517 4.623 4.623 0 01-.614 5.096 4.612 4.612 0 01-4.938 1.384 4.621 4.621 0 01-2.068-7.398 4.612 4.612 0 013.15-1.599h0z",
    stroke: "#292D3B",
    strokeWidth: 1.208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.832 18.557a3.434 3.434 0 013.686 3.162 3.434 3.434 0 11-6.846.532 3.437 3.437 0 013.16-3.694z",
    opacity: 0.47,
    fill: "#6BC6C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98 17.788a3.433 3.433 0 013.325 1.87 3.44 3.44 0 01-.454 3.792 3.431 3.431 0 01-6.03-1.972 3.436 3.436 0 013.159-3.69h0z",
    stroke: "#292D3B",
    strokeWidth: 1.208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4 1.983a3.433 3.433 0 013.326 1.871 3.44 3.44 0 01-.455 3.792 3.431 3.431 0 01-6.03-1.972 3.436 3.436 0 013.159-3.69z",
    opacity: 0.47,
    fill: "#6BC6C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.548 1.215a3.433 3.433 0 013.326 1.872 3.44 3.44 0 01-.455 3.792 3.431 3.431 0 01-6.03-1.974 3.437 3.437 0 013.16-3.69h0z",
    stroke: "#292D3B",
    strokeWidth: 1.208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.741 45.044a3.434 3.434 0 013.683 3.166 3.434 3.434 0 11-6.847.525 3.44 3.44 0 013.164-3.69z",
    opacity: 0.47,
    fill: "#6BC6C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.888 44.276a3.433 3.433 0 013.328 1.87 3.44 3.44 0 01-.454 3.792 3.431 3.431 0 01-6.03-1.972 3.436 3.436 0 013.156-3.69z",
    stroke: "#292D3B",
    strokeWidth: 1.208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.708 34.534a3.434 3.434 0 013.687 3.163 3.434 3.434 0 11-6.846.527 3.44 3.44 0 013.16-3.69z",
    opacity: 0.47,
    fill: "#6BC6C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.856 33.766a3.433 3.433 0 013.325 1.871 3.44 3.44 0 01-.454 3.792 3.431 3.431 0 01-6.03-1.973 3.438 3.438 0 013.159-3.69zM28.504 17.584l2.757-9.552M15.937 23.593L8.68 21.546M27.372 35.043l1.482 9.254",
    stroke: "#292D3B",
    strokeWidth: 1.208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

export default __webpack_public_path__ + "static/nodes.9c5d60d4.svg";
export { SvgNodes as ReactComponent };